import { NavigationTabs, type NavigationTabItem } from '@exam-management/components';
import { QSetStatus } from '@exam-management/graphql';
import { APP_PERMISSIONS } from '@exam-management/permissions';
import { usePermission } from '@shared/permissions';
import { useMemo } from 'react';

interface QSetNavigationTabsProps {
  status: QSetStatus;
}

interface QSetNavigationTabItem extends NavigationTabItem {
  status?: QSetStatus[];
}

const TAB_ITEMS: QSetNavigationTabItem[] = [
  {
    value: 'QSet Details',
    label: 'QSet Details',
    path: '/exam-courses/:courseId/qsets/:qSetId',
    requiredPermission: [APP_PERMISSIONS.EXAM.QSET.VIEW],
    status: [
      QSetStatus.Draft,
      QSetStatus.InReview,
      QSetStatus.Reviewed,
      QSetStatus.Published,
      QSetStatus.Unpublished,
      QSetStatus.Disabled,
    ],
  },
  {
    value: 'Examination Details',
    label: 'Examination Details',
    path: '/exam-courses/:courseId/qsets/:qSetId/exam-details',
    requiredPermission: [APP_PERMISSIONS.EXAM.QSET.VIEW],
    status: [
      QSetStatus.Draft,
      QSetStatus.InReview,
      QSetStatus.Reviewed,
      QSetStatus.Published,
      QSetStatus.Unpublished,
      QSetStatus.Disabled,
    ],
  },
  {
    value: 'Review History',
    label: 'Review History',
    path: '/exam-courses/:courseId/qsets/:qSetId/review-history',
    requiredPermission: [APP_PERMISSIONS.EXAM.QSET.VIEW],
    status: [
      QSetStatus.Reviewed,
      QSetStatus.Published,
      QSetStatus.Unpublished,
      QSetStatus.Disabled,
    ],
  },
  {
    value: 'Activity Log',
    label: 'Activity Log',
    path: '/exam-courses/:courseId/qsets/:qSetId/activity-log',
    requiredPermission: [APP_PERMISSIONS.EXAM.AUDIT_LOG.VIEW],
    status: [
      QSetStatus.Draft,
      QSetStatus.InReview,
      QSetStatus.Reviewed,
      QSetStatus.Published,
      QSetStatus.Unpublished,
      QSetStatus.Disabled,
    ],
  },
];

export default function QSetNavigationTabs(props: Readonly<QSetNavigationTabsProps>) {
  const { status } = props;
  const { permissions } = usePermission();

  const tabList = useMemo(
    () =>
      TAB_ITEMS.filter((tab) => {
        return (
          tab?.requiredPermission?.every((permission) => {
            return permissions.includes(permission);
          }) && tab?.status?.includes(status)
        );
      }),
    [permissions],
  );

  return <NavigationTabs items={tabList} navigateOptions={{ replace: true }} />;
}
